import { FeedRoom, SavedRoom } from "../../../../models/ChatFeed"
import { ErrorFetchingAction, FetchErrorInfo, FetchRequestActions, findChatByChatId, findChatStateByChatId, StartFetchingAction, SuccessFetchingAction } from "../../../../utils"
import { getDirectMessagesActionTypes, getDirectMessagesDataActionTypes, getDiscussionsDataActionTypes, getDocsUserInCommentsActionTypes, getDocsUserInCommentsRoomsActionTypes } from "./actions"
import { GetDocsAdditionalData, GetMessageDataAdditionalData } from "./actions/additionalData"
import { UpdateNewCommentsAction, UPDATE_NEW_COMMENTS_CHAT, UpdateDataResultAction, UPDATE_DATA_RESULT, UppendDataResultAction, UPPEND_DATA_RESULT } from "./actions/updateResults"
import { UpdateSavedRoomAction, UPDATE_SAVED_ROOM } from "./actions/updateSavedRoom"
import { UpdateSelectedChatIdAction, UPDATE_SELECTED_CHAT_ID } from "./actions/updateSelectedChatId"

export interface FeedRoomState {
    item: FeedRoom
    isDeleting: boolean
    deleteError?: FetchErrorInfo
}

export interface ChatFeedData {
    messages: FeedRoomState[]
    isFetching: boolean
    isFetchingMore: boolean
    messagesPage?: number
    hasMoreMessages?: boolean
    fetchError?: FetchErrorInfo
}

export interface ChatFeedState {
    directMessages: ChatFeedData
    documentsComments: ChatFeedData
    selectedChatId: string
    results: FeedRoom[]//temp, will removed when appears feed tabs in tuqqitalk
    fetchRoomData: {
        message: FeedRoom | null,
        type: 'push' | 'notification',
        isFetching: boolean,
        fetchError?: FetchErrorInfo
    },
    savedRoom: SavedRoom
}

const initialMessagesState: ChatFeedData = {
    messages: [],
    isFetching: false,
    isFetchingMore: false,
    messagesPage: 0,
    hasMoreMessages: false
}


export const initialChatFeedState: ChatFeedState = {
    directMessages: {...initialMessagesState},
    documentsComments: {...initialMessagesState},
    selectedChatId: '',
    results: [],
    fetchRoomData: {
        isFetching: false,
        message: null,
        type: 'notification'
    },
    savedRoom: {
        chat: {chatUId: ""},
        chatType: 'SavedMessages',
        commentText: "",
        commentTime: "2021-06-14T15:29:52.2287079Z",
        commentType: null,
        docId: "",
        document: null,
        lastCommentAttachmentType: "default",
        newComments: 0,
        userProfile: null
    }

}

type ChatFeedAdditionalData = GetDocsAdditionalData | UpdateSelectedChatIdAction  | UppendDataResultAction | UpdateNewCommentsAction | GetMessageDataAdditionalData | UpdateSavedRoomAction

export const chatFeedReducer = (state: ChatFeedState = initialChatFeedState, action: FetchRequestActions<FeedRoom[], ChatFeedAdditionalData>): ChatFeedState => {
    switch (action.type) {
        case UPDATE_DATA_RESULT: {
            const selectedChatIDAction = action as UpdateDataResultAction;

            const {chatId, result} = selectedChatIDAction
            const newState: ChatFeedState = {
                ...state,
            }
 
             const [, ind] = findChatByChatId(newState.results, chatId)
            
            if(ind < 0) return newState
            const copyResults = newState.results
            copyResults[ind] = result
            newState.results = [...copyResults]

            switch(result.chatType) {
                case 'Discussions': {
                    const [,ind] = findChatStateByChatId(state.documentsComments.messages, chatId);
                    if(ind >= 0){
                        const copyResults = newState.documentsComments.messages
                        copyResults[ind].item = result
                        newState.documentsComments.messages = [...copyResults]
                        return newState
                    }
                }
                case 'DirectMessages': {
                    const [,ind] = findChatStateByChatId(state.directMessages.messages, chatId);
                    if(ind >= 0){
                        const copyResults = newState.directMessages.messages
                        copyResults[ind].item = result
                        newState.directMessages.messages = [...copyResults]
                        return newState
                    }
                }
            }
            return newState
        }
        case UPDATE_NEW_COMMENTS_CHAT: {
            const selectedChatIDAction = action as UpdateNewCommentsAction;

            const {chatId, commentsCount, newComments} = selectedChatIDAction
            const newState: ChatFeedState = {
                ...state,
            }
            const [chat, ind] = findChatByChatId(newState.results, chatId);

            if(ind < 0) return newState

            const copyResults = newState.results
            const prevResult = copyResults[ind];
            copyResults[ind] = {...prevResult, newComments, document: {
                ...(chat.chatType === 'Discussions' ? {...prevResult.document, commentsCounter: commentsCount} : {...prevResult.document})
            }}
            newState.results = [...copyResults]

            switch(chat.chatType) {
                case 'Discussions': {
                    const [,ind] = findChatStateByChatId(state.documentsComments.messages, chatId);
                    if(ind >= 0){
                        const copyResults = newState.documentsComments.messages;
                        const prevResult = copyResults[ind].item;
                        copyResults[ind].item = {...prevResult, newComments, document: {...prevResult.document, commentsCounter: commentsCount}}
                        newState.documentsComments.messages = [...copyResults]
                        return newState
                    }
                }
                case 'DirectMessages': {
                    const [,ind] = findChatStateByChatId(state.directMessages.messages, chatId);
                    if(ind >= 0){
                        const copyResults = newState.directMessages.messages;
                        const prevResult = copyResults[ind].item;
                        copyResults[ind].item = {...prevResult, newComments: commentsCount}
                        newState.directMessages.messages = [...copyResults]
                        return newState
                    }
                }
            }
            return newState
        }
        case UPPEND_DATA_RESULT: {
            const selectedChatIDAction = action as UppendDataResultAction;

            const {result} = selectedChatIDAction

            const {docId, chatType, chat} = result;
            const id = chatType === 'Discussions' ? docId : chat.chatUId;
            
            const [, ind] = findChatByChatId(state.results, id);

            if(ind > 0) return state

            const newState: ChatFeedState = {
                ...state,
                results: [result, ...state.results]
            }
           
            switch(chatType) {
                case 'Discussions': {
                    const [,ind] = findChatStateByChatId(state.documentsComments.messages, id);
                    if(ind < 0){
                        const copyResults = newState.documentsComments.messages
                        newState.documentsComments.messages = [{item: result, isDeleting: false}, ...copyResults]
                        return newState
                    }
                }
                case 'DirectMessages': {
                    const [,ind] = findChatStateByChatId(state.directMessages.messages, id);
                    if(ind < 0){
                        const copyResults = newState.directMessages.messages
                        newState.directMessages.messages = [{item: result, isDeleting: false}, ...copyResults]
                        return newState
                    }
                }
            }
            return newState
        }

        case UPDATE_SELECTED_CHAT_ID: {
            const selectedChatIDAction = action as UpdateSelectedChatIdAction;

            const {chatUId} = selectedChatIDAction

            const newState: ChatFeedState = {
                ...state,
                selectedChatId: chatUId
            }
            return newState
        }
        case getDocsUserInCommentsActionTypes.start:
        case getDocsUserInCommentsRoomsActionTypes.start: {
            const startFetchingAction = action as StartFetchingAction<GetDocsAdditionalData>
            if (!startFetchingAction.additionalData) {
                return state
            }
    
            const newState: ChatFeedState = {
                ...state,
            }
            const {messagesPage} = startFetchingAction.additionalData
            const documentCommmentsState = state.documentsComments || { ...initialMessagesState }
            newState.documentsComments = {
                ...documentCommmentsState,
                isFetching: messagesPage as number === 0,
                isFetchingMore: messagesPage as number > 0 
            }

            return newState   
        }
        case getDocsUserInCommentsActionTypes.success: {
            const successAction = action as SuccessFetchingAction<FeedRoom[], GetDocsAdditionalData>
            if (!successAction.additionalData) {
                return state
            }
            const {messagesPage} = successAction.additionalData
            const documentMessages = state.documentsComments || { ...initialMessagesState }

            const newState: ChatFeedState = {
                ...state   
            }


            const resultMessages = successAction.result.map(x => {
                
                const commentState: FeedRoomState = {
                    item: x,
                    isDeleting: false
                }
                const {docId, document: {commentsCounter}} = x
                const [prevChat, ind] = findChatByChatId(state.results, docId);
                
                if(ind < 0) return commentState

                const newComments = commentsCounter - prevChat.document.commentsCounter;
                commentState.item = {
                    ...commentState.item,
                    newComments,
                    document: {
                        ...commentState.item.document,
                        commentsCounter: commentsCounter - newComments
                    }
                }
                return {...commentState}
            })
            const newMessages = messagesPage as number > 0 ? [ ...resultMessages, ...documentMessages.messages] : resultMessages
           
            newState.documentsComments = {
                ...documentMessages,
                isFetching: false,
                isFetchingMore: false,
                hasMoreMessages:  resultMessages.length > 0,
                messagesPage,
                messages:  newMessages
            }
            // temp
            newState.results = [...newState.directMessages.messages.map(dm=> dm.item), ...newMessages.map(doc => doc.item)]

            return newState 
        }
        case getDocsUserInCommentsRoomsActionTypes.success: {
            const successAction = action as SuccessFetchingAction<FeedRoom[], GetDocsAdditionalData>
            if (!successAction.additionalData) {
                return state
            }
            const {messagesPage} = successAction.additionalData
            const documentMessages = state.documentsComments || { ...initialMessagesState }

            const newState: ChatFeedState = {
                ...state   
            }


            const resultMessages = successAction.result.map(x => {
                const commentState: FeedRoomState = {
                    item: x,
                    isDeleting: false
                }
                return commentState
            })
            const newMessages = messagesPage as number > 0 ? [ ...resultMessages, ...documentMessages.messages] : resultMessages
           
            newState.documentsComments = {
                ...documentMessages,
                isFetching: false,
                isFetchingMore: false,
                hasMoreMessages:  resultMessages.length > 0,
                messagesPage,
                messages:  newMessages
            }
            // temp
            newState.results = [...newState.directMessages.messages.map(dm=> dm.item), ...newMessages.map(doc => doc.item)]
            return newState 
        }
        case getDocsUserInCommentsActionTypes.error:
        case getDocsUserInCommentsRoomsActionTypes.error: {
            const errorAction = action as ErrorFetchingAction<GetDocsAdditionalData>
            if (!errorAction.additionalData) {
                return state
            }
            const documentMessages = state.documentsComments || { ...initialMessagesState }
            const newState: ChatFeedState = {
                ...state,
                documentsComments: {
                    ...documentMessages,
                    isFetching: false,
                    fetchError: errorAction.error
                    }
                }
            return newState
        }
        case getDirectMessagesActionTypes.start: {
            const startFetchingAction = action as StartFetchingAction<GetDocsAdditionalData>
            if (!startFetchingAction.additionalData) {
                return state
            }
    
            const newState: ChatFeedState = {
                ...state
            }
            const {messagesPage} = startFetchingAction.additionalData
            const documentCommmentsState = state.directMessages || { ...initialMessagesState }
            newState.directMessages = {
                ...documentCommmentsState,
                isFetching: messagesPage as number === 0,
                isFetchingMore: messagesPage as number > 0 
            }
            return newState   
        }
        case getDirectMessagesActionTypes.success: {
            const successAction = action as SuccessFetchingAction<FeedRoom[], GetDocsAdditionalData>
            if (!successAction.additionalData) {
                return state
            }
            const {messagesPage} = successAction.additionalData
            const documentMessages = state.directMessages || { ...initialMessagesState }
            const newState: ChatFeedState = {
                    ...state
            }
            const resultMessages = successAction.result.map(x => {
                const commentState: FeedRoomState = {
                    item: x,
                    isDeleting: false
                }
                return commentState
            })
            const newMessages = messagesPage as number > 0 ? [ ...resultMessages, ...documentMessages.messages] : resultMessages;
            
            newState.directMessages = {
                ...documentMessages,
                isFetching: false,
                isFetchingMore: false,
                hasMoreMessages:  resultMessages.length > 0,
                messagesPage,
                messages: newMessages
            }
            // temp
            newState.results = [...newState.documentsComments.messages.map(doc=> doc.item), ...newMessages.map(doc => doc.item)]
            return newState 
        }
        case getDirectMessagesActionTypes.error: {
            const errorAction = action as ErrorFetchingAction<GetDocsAdditionalData>
            if (!errorAction.additionalData) {
                return state
            }
            const documentMessages = state.directMessages || { ...initialMessagesState }
            const newState: ChatFeedState = {
                ...state,
                directMessages: {
                    ...documentMessages,
                    isFetching: false,
                    fetchError: errorAction.error
                }
            }
            return newState
        }
        case getDirectMessagesDataActionTypes.start: {       
            const startAction = action as StartFetchingAction<GetMessageDataAdditionalData>
            if (!startAction.additionalData) {
                return state
            }    
            const messageData = state.fetchRoomData
    
            const newState: ChatFeedState = {
                ...state
            }
            newState.fetchRoomData = {
                ...messageData,
                type: startAction.additionalData.type,
                message: null,
                isFetching: true
            }
            return newState   
        }
        case getDirectMessagesDataActionTypes.success: {
            const successAction = action as SuccessFetchingAction<FeedRoom>
            const messageData = state.fetchRoomData

            const newState: ChatFeedState = {
                ...state
            }
            newState.fetchRoomData = {
                ...messageData,
                isFetching: false,
                message: successAction.result
            }            
           
            return newState 
        }
        case getDirectMessagesDataActionTypes.error: {
            const errorAction = action as ErrorFetchingAction
            const messageData = state.fetchRoomData

            const newState: ChatFeedState = {
                ...state
            }
            newState.fetchRoomData = {
                ...messageData,
                isFetching: false,
                message: null,
                fetchError: errorAction.error
            }    
            return newState
        }
        case getDiscussionsDataActionTypes.start: {   
            const startAction = action as StartFetchingAction<GetMessageDataAdditionalData>
            if (!startAction.additionalData) {
                return state
            }   
            const messageData = state.fetchRoomData
            const newState: ChatFeedState = {
                ...state
            }
            newState.fetchRoomData = {
                ...messageData,
                type: startAction.additionalData.type,
                message: null,
                isFetching: true
            }
            return newState   
        }
        case getDiscussionsDataActionTypes.success: {
            const successAction = action as SuccessFetchingAction<FeedRoom>
            const messageData = state.fetchRoomData

            const newState: ChatFeedState = {
                ...state
            }
            newState.fetchRoomData = {
                ...messageData,
                isFetching: false,
                message: successAction.result
            }   
            return newState 
        }
        case getDiscussionsDataActionTypes.error: {
            const errorAction = action as ErrorFetchingAction
            const messageData = state.fetchRoomData

            const newState: ChatFeedState = {
                ...state
            }
            newState.fetchRoomData = {
                ...messageData,
                isFetching: false,
                message: null,
                fetchError: errorAction.error
            }    
            return newState
        }
        case UPDATE_SAVED_ROOM: {
            const selectedChatIDAction = action as UpdateSavedRoomAction;

            const {result} = selectedChatIDAction
            const newState: ChatFeedState = {
                ...state,
            }
 
            newState.savedRoom = {...newState.savedRoom, ...result}
            return newState
        }
        default:
            return state
    }
    
}